<template>
  <div class="page">
    <div class="content">
      <van-row>
        <van-col span="18" offset="3">
          <deng></deng>
        </van-col>
      </van-row>

      <div class="m-top-10">
        <div v-if="switchBtn === 'email'">
          <van-row>
            <van-col span="20" offset="2">
              <van-cell-group class="input-simple">
                <van-field
                  v-model="params.email"
                  center
                  clearable
                  placeholder="输入电子邮箱地址"
                  class="input-simple"
                >
                  <van-button
                    slot="button"
                    size="small"
                    type="default"
                    class="input-switch"
                    style="text-align: left"
                    @click="handlerSwitchEmailOrMobile('mobile')"
                  >
                    <van-image
                      class="img-btn fadeInRight animated"
                      width="35"
                      :src="image.email"
                      style="margin-left: -8px; margin-top: 1px"
                    />
                  </van-button>
                </van-field>
              </van-cell-group>
            </van-col>
          </van-row>
        </div>

        <div v-else>
          <van-row>
            <van-col span="20" offset="2">
              <van-cell-group class="input-simple">
                <van-field
                  v-model="params.mobile"
                  center
                  clearable
                  placeholder="输入11位手机号"
                  class="input-simple"
                  label-width="65"
                  maxlength="11"
                  @change="handlerMobileChange()"
                  @blur="handlerMobileBlur()"
                  @input="handlerMobileInputChange()"
                >
                  <div slot="label">
                    + 86 <span style="margin-left: 10px">|</span>
                  </div>
                  <van-button
                    slot="button"
                    size="small"
                    type="default"
                    class="input-switch"
                    @click="handlerSwitchEmailOrMobile('email')"
                  >
                    <van-image
                      class="img-btn fadeInLeft animated"
                      width="35"
                      :src="image.mobile"
                      style="margin-right: -23px; margin-top: 1px"
                    />
                  </van-button>
                </van-field>
              </van-cell-group>
            </van-col>
          </van-row>
        </div>

        <van-row>
          <van-col span="20" offset="2">
            <van-cell-group class="input-simple">
              <van-field
                v-model="params.authCode"
                center
                clearable
                :placeholder="
                  '输入' + (switchBtn === 'mobile' ? '验证码' : '密码')
                "
                class="input-simple"
              >
                <van-button
                  slot="button"
                  size="small"
                  type="default"
                  class="send-auth-btn"
                  @click="handleSendCode"
                  v-if="switchBtn === 'mobile'"
                >
                  {{ authMsg }}
                </van-button>
              </van-field>
            </van-cell-group>
          </van-col>
        </van-row>

        <van-row>
          <van-col span="20" offset="2" class="privacyPolicy">
            <input
              type="checkbox"
              v-model="params.privacyPolicy"
              value="1"
              id="privacyPolicy"
              @change="handlerCheckPrivacyPolicy"
            /><label @click="handlerSelectPrivacyPolicy()"
              >我已阅读并理解《中国员工入职管理平台隐私声明》，并同意按该声明的规定处理我的信息</label
            >
          </van-col>
        </van-row>

        <van-row class="m-top-5">
          <van-col span="14" offset="5">
            <van-button
              size="small"
              type="default"
              class="img-btn"
              style="
                height: 50px;
                background: #0f0f0f;
                border: 1px solid #0f0f0f;
                color: #ffffff;
                font-size: 18px;
                font-weight: bold;
                border-radius: 30px;
              "
              @click="doLogin"
            >
              继续 ->
            </van-button>
            <!--<img class="img-btn" src="../assets/images/start_btn.png" @click="doLogin">-->
          </van-col>
        </van-row>
      </div>
    </div>

    <van-dialog
      v-model="isShowPrivacyPolicy"
      show-confirm-button
      style="background: #f6f8ec"
    >
      <div class="privacy-desc">
        <p class="tc bold f16">
          Privacy Notice of Employee Onboarding Platform in China
        </p>
        <p class="tc bold f16">中国员工入职管理平台隐私声明</p>
        <p class="mt-10 bold">Introduction</p>
        <p class="bold">简介</p>
        <p class="mt-10">
          For information not covered in this Privacy Notice of Employee
          Onboarding Platform (“<span class="bold">Notice</span>”) pertaining to
          the WeChat onboarding platform (“<span class="bold">Platform</span>”),
          please refer to the
          <a
            href="http://getreadycreators.wework.cn/email/WeWork_-_Employee_Privacy_Policy_-_December_2018.pdf"
            target="_blank"
            >WeWork Privacy Policy for People Data</a
          >
          (“<span class="bold">Employee Policy</span>”) for further information.
          Terms defined in the Employee Policy shall have the same meaning in
          this Notice, except where a term is specifically defined in this
          Notice. In case of any inconsistency between this Notice and the
          Employee Policy, this Notice will prevail.
        </p>
        <p class="mt-10">
          对于涉及微信入职管理平台（“<span class="bold">平台</span
          >”）但本员工入职管理平台隐私声明（“<span class="bold">声明</span
          >”）未涵盖的信息，请参阅<a
            href="http://getreadycreators.wework.cn/email/WeWork_-_Employee_Privacy_Policy_-_December_2018.pdf"
            target="_blank"
            >WeWork个人数据隐私政策</a
          >（“<span class="bold">员工政策</span
          >”）了解进一步信息。员工政策与本声明中的定义术语应当具有相同的含义，除非本声明中另有明确定义。如果本声明和员工政策存在任何不一致，以本声明为准。
        </p>
        <p class="mt-10 bold">
          What Personal Information this Platform Collects
        </p>
        <p class="bold">本平台收集哪些个人信息</p>
        <p class="mt-10">
          In accordance with applicable Chinese laws, regulations, and standards
          (“<span class="bold">Applicable Chinese Law</span>”), below are the
          types of Personal Information this Platform may collect about you:
        </p>
        <p class="mt-10">
          根据适用的中国法律、法规和标准（“<span class="bold"
            >适用的中国法律</span
          >”），以下是本平台可能收集的关于你的个人信息类型：
        </p>
        <div class="list">
          <ul>
            <li class="mt-10">
              <span class="bold">government-issued ID</span>, such as
              <span class="bold">passports</span> and
              <span class="bold">national identification card</span>;
            </li>
            <li class="mt-10">
              <span class="bold">政府颁发的身份证件</span>，例如<span
                class="bold"
                >护照</span
              >和<span class="bold">身份证</span>
            </li>
            <li class="mt-10">
              your name, date of birth, gender, and nationality;
            </li>
            <li class="mt-10">你的姓名、出生日期、性别、以及国籍；</li>
            <li class="mt-10">
              your personal home postal address,
              <span class="bold">personal email address</span>, and
              <span class="bold">phone number</span>;
            </li>
            <li class="mt-10">
              你的家庭通讯地址、<span class="bold">个人电子邮箱地址</span
              >、以及<span class="bold">电话号码</span>；
            </li>
            <li class="mt-10">certificate for highest degree obtained;</li>
            <li class="mt-10">取得的最高学历证书；</li>
            <li class="mt-10">
              name of your last employer and employment end date;
            </li>
            <li class="mt-10">你上一任雇主名称以及雇佣终止日期；</li>
            <li class="mt-10">
              your location of hire and start date with WeWork;
            </li>
            <li class="mt-10">你受聘于WeWork的工作地点以及起始日期；</li>
            <li class="mt-10">certificate of separation with last employer;</li>
            <li class="mt-10">你从上一任雇主离职的证明；</li>
            <li class="mt-10">
              <span class="bold"
                >report about your basic physical state of health</span
              >
              of recent 3 months, issued by a healthcare professional (such as
              your medical check report).
            </li>
            <li class="mt-10">
              医疗专业机构出具的关于你最近3个月的<span class="bold"
                >基本健康状况的报告</span
              >（例如你的体检报告）。
            </li>
          </ul>
        </div>

        <p class="mt-10">
          Some information listed above, such as your ID, personal email address
          and phone number, and report about your basic physical state of health
          may be considered sensitive Personal Information under Applicable
          Chinese Law. We take appropriate measures to protect and use your
          sensitive Personal Information.
        </p>
        <p class="mt-10">
          根据适用的中国法律，以上所列的部分信息，例如你的身份证件、个人电子邮箱地址和电话号码、以及关于你基本健康状况的报告，可能被视为个人敏感信息。我们采取适当的措施来保护和使用你的个人敏感信息。
        </p>
        <p class="mt-10">
          We may also collect your self-portrait and a description of your
          interests or hobbies if you provide your consent to us.
        </p>
        <p class="mt-10">
          经你同意，我们还可能收集你的自拍照片以及关于你兴趣或爱好的信息。
        </p>
        <p class="mt-10 bold">
          This Platform’s Uses of Your Personal Information
        </p>
        <p class="mt-10 bold">本平台对你个人信息的使用</p>
        <p class="mt-10">
          We use your Personal Information for purposes including:
        </p>
        <p class="mt-10">我们使用你个人信息的目的包括：</p>
        <div class="list">
          <ul>
            <li class="mt-10">
              administering the employment relationship and facilitating your
              onboarding process (e.g., assessing whether you are in an adequate
              physical state for work, establishing new hire profiles, carrying
              out identity verification) and managing the workforce in general;
            </li>
            <li class="mt-10">
              管理雇佣关系、推进你的入职流程（例如评估你是否具备适合工作的健康状况、建立新的雇佣关系档案、进行身份验证）、以及对员工进行综合管理；
            </li>
            <li class="mt-10">
              processing your Personal Information, including sensitive Personal
              Information, in order to comply with Applicable Chinese Law;
            </li>
            <li class="mt-10">
              处理你的个人信息，包括个人敏感信息，从而遵守适用的中国法律；
            </li>
            <li class="mt-10">
              providing personalized product experience based on your hire
              location and citizenship.
            </li>
            <li class="mt-10">
              基于你的工作地点和国籍，提供个性化的产品体验。
            </li>
          </ul>
        </div>
        <p class="mt-10">
          If you have any questions about this Notice or questions or complaints
          about the processing of your Personal Information by us, please email
          <a href="mailto:gccompliance@wework.cn">gccompliance@wework.cn</a>.
        </p>
        <p class="mt-10">
          如果你对本声明有任何问题，或者对我们处理你的个人信息有任何疑问或投诉，请发送电子邮件至<a
            href="mailto:gccompliance@wework.cn"
            >gccompliance@wework.cn</a
          >。
        </p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import {
  Row,
  Col,
  Field,
  Image,
  Button,
  CellGroup,
  Toast,
  Checkbox,
  Dialog,
} from "vant";
import Deng from "../components/deng";
import md5 from "js-md5";

const lang_auth_code = "发送验证码";

export default {
  name: "Login",
  components: {
    [Deng.name]: Deng,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [Image.name]: Image,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      hasSendAuth: false,
      authCodeRestSendTime: 0,
      switchBtn: "mobile",
      image: {
        email: require("../assets/images/email.png"),
        mobile: require("../assets/images/mobile.png"),
        authCode: require("../assets/images/send_code.png"),
      },
      params: {
        privacyPolicy: false,
        email: "",
        mobile: "",
        authCode: "",
      },
      authMsg: lang_auth_code,
      isShowPrivacyPolicy: false,
      code: "",
      openId: "",
    };
  },
  computed: {
    ...mapGetters(["checkLogin", "getUserInfo", "getBusinessData"]),
  },
  methods: {
    ...mapMutations(["login", "logout", "setBusinessData"]),
    handlerCheckPrivacyPolicy() {
      this.isShowPrivacyPolicy = this.params.privacyPolicy;

      let aHeight =
        parseInt(
          document.documentElement.clientHeight || document.body.clientHeight
        ) - 180;

      //van-dialog__content
      this.$nextTick(() => {
        document.getElementsByClassName("van-dialog__content")[0].style.height =
          aHeight + "px";
      });
    },
    handlerSelectPrivacyPolicy() {
      this.params.privacyPolicy = !this.params.privacyPolicy;
      this.handlerCheckPrivacyPolicy();
    },
    handlerSwitchEmailOrMobile(btnName) {
      this.switchBtn = btnName;
    },
    handlerMobileChange() {
      if (this.authMsg === "发送验证码") {
        this.hasSendAuth = false;
      } else {
      }
    },
    handlerMobileBlur() {},
    handlerMobileInputChange() {},
    handleSendCode() {
      if (this.hasSendAuth) {
        return false;
      }

      this.hasSendAuth = true;

      this.$api
        .doPost("/login/sendSmsCode", { mobile: this.params.mobile })
        .then((res) => {
          this.authMsg = this.authCodeRestSendTime + " 秒后可重发";
          let authCodeInterval = setInterval(() => {
            this.authCodeRestSendTime--;
            if (this.authCodeRestSendTime <= 0) {
              clearInterval(authCodeInterval);
              this.authCodeRestSendTime = this.$config.AUTH_CODE_TIME;
              this.hasSendAuth = false;
              this.authMsg = lang_auth_code;
            } else {
              this.authMsg = this.authCodeRestSendTime + " 秒后可重发";
            }
          }, 1000);
        });
    },
    doLogin() {
      if (this.switchBtn === "email") {
        if (!this.params.email) {
          Toast.fail("邮箱不能为空！");
          return false;
        }
      } else {
        if (!this.params.mobile) {
          Toast.fail("手机不能为空！");
          return false;
        }
      }
      if (!this.params.authCode) {
        if (this.switchBtn === "email") {
          Toast.fail("密码不能为空！");
        } else {
          Toast.fail("验证码不能为空！");
        }
        return false;
      }

      if (!this.params.privacyPolicy) {
        Toast.fail("请阅读并勾选隐私条款！");
        return false;
      }

      let params = {};
      if (this.switchBtn === "email") {
        params.email = this.params.email;
        params.password = md5(this.params.authCode);
      } else {
        params.mobile = this.params.mobile;
        params.code = this.params.authCode;
      }

      if (this.openId) {
        params.openId = this.openId;
      }

      this.$api.doPost("/login/login", params).then((res) => {
        this.handleLoginSuccess(res);
      });
    },

    handleLoginSuccess(res) {
      this.$emit("audioPlay", true);
      let info = res.customer;
      info.originName = info.name;
      info.name = info.nickName;
      info.token = res.sessionId;
      this.login(info);
      this.$router.push("/home");

      const { systemInfo } = this.$store.state;
      this.$api.doPost("/dataMonitor/saveUseAmountData", {
        dataName: systemInfo.deviceType,
        type: 1,
      });
    },

    getOpenId(code) {
      this.$api.doPost("/login/WxAppletLogin", { code }).then((res) => {
        if (typeof res === "string") {
          this.openId = res;
        } else {
          this.handleLoginSuccess(res);
        }
      });
    },
  },
  created() {
    this.$emit("prev", false);
    this.authCodeRestSendTime = this.$config.AUTH_CODE_TIME;
  },
  mounted() {
    const { code } = this.$route.query;
    this.code = code;
    if (code) {
      this.getOpenId(code);
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: url("../assets/images/login_bg.jpg") no-repeat center top;
  background-size: cover;
  overflow-y: auto;
}

.content {
  width: 100%;
  margin-top: 25%;
  .input-simple {
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    margin-bottom: 15px;
    font-size: 16px;
    height: 55px;

    .input-switch {
      width: 70px;
      height: 42px;
      padding: 0 auto;
      margin-top: 3px;
      border: 2px solid #222222;
      border-radius: 35px;
    }
  }

  .send-auth-btn {
    height: 35px;
    width: 120px;
    border-radius: 30px;
    background: black;
    color: white;
    font-weight: bold;
    font-size: 14px;
  }
}

.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border: none;
}

.privacyPolicy {
  color: #d6d6d6;
  font-size: 14px;
  font-weight: 500;
  text-align: left;

  input[type="checkbox"] {
    width: 14px;
    height: 14px;
    vertical-align: text-top;
    margin-right: 2px;
  }
}

.privacy-desc {
  position: relative;
  height: calc(100% - 10px);
  padding: 10px;
  overflow-y: auto;
  font-size: 14px;

  .mt-5 {
    margin-top: 5px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .tc {
    text-align: center;
  }

  .bold {
    font-weight: bold;
  }

  .f16 {
    font-size: 16px;
  }

  .list {
    margin-left: 10px;
  }

  .list ul {
    margin-left: 10px;
  }

  .list li {
    list-style-type: initial;
  }

  a {
    color: #000;
    border-bottom: 1px solid #000;
  }
}
</style>
